"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABS = void 0;
var TABS = {
  BUTTON__STOCK_CREDIT_TAB: 'singleCreditNoteTabs-button-stockCreditTab',
  BUTTON__NOTES_TAB: 'singleCreditNoteTabs-button-notesTab',
  STOCK_CREDIT: {
    TEXT__PRODUCT_NAME: 'singleCreditNoteStockCreditTab-span-productName',
    TEXT__PRODUCT_PRICE: 'singleCreditNoteStockCreditTab-span-productPrice',
    TEXT__PRODUCT_UNIT: 'singleCreditNoteStockCreditTab-span-productUnit',
    TEXT__PRODUCT_SKU: 'singleCreditNoteStockCreditTab-span-productSKU',
    TEXT__PRODUCT_QUANTITY: 'singleCreditNoteStockCreditTab-span-productQuantity',
    TEXT__PRODUCT_TOTAL: 'singleCreditNoteStockCreditTab-span-productTotal',
    BUTTON__EDIT_PRODUCT: 'singleCreditNoteStockCreditTab-button-editProduct',
    BUTTON__DELETE_PRODUCT: 'singleCreditNoteStockCreditTab-button-deleteProduct',
    TEXT__ADDITIONAL_ITEM_TITLE: 'singleCreditNoteStockCreditTab-span-additionalItemTitle',
    TEXT__ADDITIONAL_ITEM_DESCRIPTION: 'singleCreditNoteStockCreditTab-span-additionalItemDescription',
    TEXT__ADDITIONAL_ITEM_AMOUNT: 'singleCreditNoteStockCreditTab-span-additionalItemAmount',
    BUTTON__EDIT_ADDITIONAL_ITEM: 'singleCreditNoteStockCreditTab-button-editAdditionalItem',
    BUTTON__DELETE_ADDITIONAL_ITEM: 'singleCreditNoteStockCreditTab-button-deleteAdditionalItem',
    BUTTON__ADD_NON_STOCK_CREDIT: 'singleCreditNoteStockCreditTab-button-addNonStockCredit'
  },
  NOTES: {
    TEXT__USER: 'singleCreditNoteNotesTab-span-user',
    TEXT__NOTE: 'singleCreditNoteNotesTab-span-note',
    TEXT__DATE: 'singleCreditNoteNotesTab-span-date'
  }
};
exports.TABS = TABS;